import React from 'react';
import './src/styles/global.css' // TailwindCSS
import {AnimatePresence} from 'framer-motion';

export const wrapPageElement = ({element, props}) => (
  <AnimatePresence mode="wait" pageContext={props.pageContext}>{element}</AnimatePresence>
);